import { httpGet, httpPost } from '../../../utils/api.utils';
import { REQUEST_TYPES_ID as RequestType } from '../../../constants/external-constants';

export async function getAddresses (
    dispatch,
    actionType,
    value,
    showOtherAddress = false,
    page = 1,
    searchString = null,
    loadingType
) {
    const pageSize = 15;
    dispatch({ type: loadingType, payload: true });

    try {
        const res = await httpGet(
            getUrlLocationAddress(value, showOtherAddress, page, pageSize, searchString)
        );

        if (res) {
            dispatch({
                type: actionType,
                payload: {
                    address: res,
                    addressPage: page
                }
            });
        } else {
            dispatch({ type: actionType, payload: [] });
        }
    } catch (e) {
        console.error("Error in getAddresses:", e);
        dispatch({ type: actionType, payload: [] });
    } finally {
        dispatch({ type: loadingType, payload: false });
    }
}
export async function planTypeOptions(dispatch, actionType, id, circuitCategoryId, page = 1, searchString = null, loadingType) {
    const pageSize = 15;

    dispatch({
        type: loadingType
        , payload: true
    })

    let url = `external/orderRequest/GetPlanOptionsByVendorByCircuitType/${id}/${circuitCategoryId}/${page}/${pageSize}`
    if (searchString) {
        url += `/${encodeURIComponent(searchString)}`;
    }
    var res = await httpGet(url)


    try {
        if (res != null) {
            dispatch({
                type: actionType
                , payload: {
                    planType: res
                    , planPage: page
                }
            });
        } else {
            dispatch({ type: actionType, data: [] });
        }

        return res != null && res.ok !== false;
    }
    catch (e) {
        return null;
    }
    finally {
        dispatch({
            type: loadingType
            , payload: false
        })
    }
}

export async function updatePlanTypes(dispatch, actionType, id, circuitCategoryId) {
    var res = await httpGet('external/orderRequest/GetPlanByVendorByCircuitType/' + id + '/' + circuitCategoryId);
    if (res != null) {
        dispatch({ type: actionType, data: res });
    } else {
        dispatch({ type: actionType, data: [] });
    }

    return res != null && res.ok !== false;
}

export async function updatePlanTypesByCircuitType(dispatch, actionType, id, circuitTypeId) {
    var res = await httpGet('external/orderRequest/getPlanByVendorByCircuitType/' + id + '/' + circuitTypeId);
    if (res != null && res.length > 0) {
        dispatch({ type: actionType, data: res });
    } else {
        dispatch({ type: actionType, data: [] });
    }
}

export async function getVendorDetails(dispatch, actionType, defaultState, id) {
    var res = await httpPost('external/orderRequest/getVendorDetails', { VendorDetailId: id });
    if (res != null) {
        dispatch({ type: actionType, data: res });
    } else {
        dispatch({ type: actionType, data: { ...defaultState } });
    }
    return res != null;
}

export async function getUserLocation(dispatch, actionType, requestId) {

    let url = getUrlUserLocation(requestId);

    var res = await httpPost(url, { EmployeeId: parseInt(sessionStorage.EmployeeID) });

    if (res && Object.keys(res).length > 0) {
        dispatch({ type: actionType, data: res });
    } else {
        dispatch({ type: actionType, data: {} });
    }
}

export function addZeroes(num) {
    var numberAsString = num.toString();

    if (numberAsString.indexOf('.') === -1) {
        num = num.toFixed(2);
        numberAsString = num.toString();
    } else if (numberAsString.split(".")[1].length < 3) {
        num = num.toFixed(2);
        numberAsString = num.toString();
    }

    return numberAsString
}

function getUrlUserLocation(id) {
    switch (id) {
        case RequestType.simReplacement:
            return 'external/replaceSim/getUserLocation';
        case RequestType.deviceReplacement:
        case RequestType.accessory:
        case RequestType.changeVendor:
            return 'external/replaceDevice/getUserLocationAddress';
        default:
            return '';
    }
}

function getUrlLocationAddress(countryCode, showOtherAddress, page, pageSize, searchString) {
    let url = `external/orderRequest/getLocationAddressOptions/${page}/${pageSize}/${countryCode}`;

    if (searchString) {
        url += `/${encodeURIComponent(searchString)}`;
    }
    return url;
}